import React from "react"
import { Grid } from "@mui/material"

import * as S from "./investors.styles"

const Investors = ({ description, logos }) => {
  return (
    <S.Section>
      <S.Wrapper>
        <S.Description>{description}</S.Description>
        <S.LogosContainer>
          {logos?.map(({ image }, index) => (
            <S.ImageContainer key={`logo-image-${index}`}>
              <S.Image img={image} className={index === 0 ? "large" : ""} />
            </S.ImageContainer>
          ))}
        </S.LogosContainer>
      </S.Wrapper>
    </S.Section>
  )
}

export default Investors
